import { render, staticRenderFns } from "./ChatRoomPrimaryInfo.htm?vue&type=template&id=973fd5b4&scoped=true&"
import script from "./ChatRoomPrimaryInfo.ts?vue&type=script&lang=js&"
export * from "./ChatRoomPrimaryInfo.ts?vue&type=script&lang=js&"
import style0 from "./ChatRoomPrimaryInfo.scss?vue&type=style&index=0&id=973fd5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973fd5b4",
  null
  
)

export default component.exports